import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {StorageService} from './storage.service';
import * as LZString from 'lz-string';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {
  public permissons$ = new BehaviorSubject<DeepPartial<UserRights> | null>(null)


  constructor(private storage: StorageService) {
    const str = this.storage.getItem('perm');
    if (str) {
      const permissions = JSON.parse(LZString.decompress(str));
      this.permissons$.next(permissions);
    }
  }

  setPermissions(permissions: UserRights) {
    this.permissons$.next(permissions)
    const str = JSON.stringify(permissions);
    this.storage.setItem('perm', LZString.compress(str));
  }

  updatePermissions(permissions: DeepPartial<UserRights>) {
    this.permissons$.next({...this.permissons$.value, ...permissions});
  }
}
